import { render, staticRenderFns } from "./PlayerHistoriCard.vue?vue&type=template&id=4da2a4c4"
import script from "./PlayerHistoriCard.vue?vue&type=script&lang=js"
export * from "./PlayerHistoriCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports